import { getTransactionHistory } from '~/api/transaction';
import { humanizeTimestamp } from '~/utils/date-helper';
import { BUKA20_TRANSACTION_TYPES, BUKA20_ALLOWED_BUKABANTUAN_TRANSACTION_TYPES } from '~/utils/buka20-constants';

function formatTrxList(prev, next) {
  if (
    next.trx_type === BUKA20_TRANSACTION_TYPES &&
    !BUKA20_ALLOWED_BUKABANTUAN_TRANSACTION_TYPES.includes(next.detail.transaction_type)
  ) {
    return prev;
  }

  const currentDate = new Date(next.created_at);
  if (prev.length === 0 || new Date(prev[prev.length - 1]?.['created_at']).getDate() !== currentDate.getDate()) {
    prev.push({
      divider: true,
      text: humanizeTimestamp(currentDate),
      uid: `date-${currentDate.getTime()}`,
    });
  }

  prev.push({ ...next, uid: next.detail?.id || next.detail?.transaction_id });
  return prev;
}

export const state = () => ({
  showHistoryTransactionPulsa: false,
});

export const getters = {
  showHistoryTransactionPulsa(state) {
    return state.showHistoryTransactionPulsa;
  },
};

export const mutations = {
  setShowHistoryTransactionPulsa(state, value) {
    state.showHistoryTransactionPulsa = value;
  },
};

export const actions = {
  openHistoryTransactionPulsaSheet({ commit, state }) {
    if (state.showHistoryTransactionPulsa) return;
    commit('setShowHistoryTransactionPulsa', true);
  },
  dismissHistoryTransactionPulsa({ commit, state }) {
    if (!state.showHistoryTransactionPulsa) return;
    commit('setShowHistoryTransactionPulsa', false);
  },
  async fetchHistoryTransactionPulsa() {
    try {
      const params = [
        {
          trxType: 'buka20-transactions',
          apiVersion: 2,
        },
      ];
      const response = await Promise.all(params.map(param => getTransactionHistory(this.$axios, param)));
      return response
        .reduce((acc, resp) => {
          if (resp.meta.http_status !== 200) return [];
          return acc.concat(resp.data);
        }, [])
        .filter(item => {
          if (item.trx_type === 'buka20-transactions') {
            return item.detail.transaction_type === 'prepaid-phone-topup';
          }
          return item.detail.transactions[0].type === 'phone-credit-prepaid';
        })
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        .reduce(formatTrxList, []);
    } catch (error) {
      console.error('[ERROR FETCH TRANSACTION HISTORY]', error);
      return [];
    }
  },
  async fetchHistoryTransaction() {
    const params = [
      {
        trxType: 'grocery',
      },
      {
        trxType: 'buka20-transactions',
        apiVersion: 2,
      },
      {
        trxType: 'topup',
      },
    ];
    try {
      const response = await Promise.all(params.map(param => getTransactionHistory(this.$axios, param)));
      return response
        .reduce((acc, resp) => {
          if (resp.meta.http_status !== 200) return [];
          return acc.concat(resp.data);
        }, [])
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    } catch (error) {
      console.error('[ERROR FETCH TRANSACTION HISTORY]', error);
      return [];
    }
  },
};
